import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
});
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);
export const apiUpload = axios.create({
  baseURL: process.env.REACT_APP_API_UPLOAD_URL || 'http://localhost:3000',
});

export function authHeader() {
  const value = localStorage.getItem('user');
  const user = typeof value === 'string' ? JSON.parse(value) : undefined;

  if (user && user.token) {
    return { Authorization: 'Bearer ' + user.token };
  } else {
    return undefined;
  }
}

export type FormError = { field: string; errors: string[] };

export type ApiResponse<T> = {
  data: T;
  errors?: FormError[];
  code: number;
  message: string;
};

export default api;
